import Client from "../AxiosClient";
const resource = "/private/notifications";

export default {
  async pushNotification(data) {
    try {
        const response = await Client.post(`${resource}`,data);
        return response;
    } catch (error) {
        return {
            "status": "failed",
            "data": [],
            "message": error.message
        }
    }
  },
  async getNotification(read, feature) {
      try {
          read = read !== undefined ? read : null;
          feature = feature !== undefined ? feature : "";
          const response = await Client.get(`${resource}?read=${read}&feature=${feature}`);
          return response;
      } catch (error) {
          return {
              "status": "failed",
              "data": [],
              "message": error.message
          }
      }
  },
  async updateNotification(id) {
      try {
          const response = await Client.put(`${resource}`,id);
          return response;
      } catch (error) {
          return {
              "status": "failed",
              "data": [],
              "message": error.message
          }
      }
  },

  update(payload) {},

  delete(id) {},
};
